export default "__VITE_ASSET__9744b49f__"